'use client'

// src/api/cache.ts
var CURRENCY_CACHE = [];
var CURRENCY_EXCHANGE_CACHE = /* @__PURE__ */ new Map();

export {
  CURRENCY_CACHE,
  CURRENCY_EXCHANGE_CACHE
};
//# sourceMappingURL=chunk-XYTTLPTA.mjs.map